export default "__VITE_ASSET__Smn2W4IB__"